import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { fetchInHouseUsersData } from "../../../redux/reducers/dropdownApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { ticketUserRoleSchema } from "../../../schema/schema";
import { ticket_user_role_mapping } from "../../../data/ApiEndpoints";

const TicketUserForm = ({
  ticketUserEnumData,
  refetchTicketUserRoles,
  onCloseModal,
  modValues,
  token,
}) => {
  const dispatch = useDispatch();
  const { inhouseUsers } = useSelector((state) => state.dropdown);

  const isEdit = modValues.cardName === "edit";
  const rowData = modValues.rowData;

  useEffect(() => {
    dispatch(
      fetchInHouseUsersData({
        token: token,
        qps: "user_types=admin,cluster_manager,club_manager,fitness_manager,sales_manager",
        pageNo: 1,
        limit: 100,
      })
    );
  }, []);

  const formatedTicketUserEnumData = ticketUserEnumData?.data?.map((item) => ({
    label: item?.name,
    value: item?.value || item?.id,
  }));

  const formik = useFormik({
    initialValues: {
      selectedUser:
        isEdit && rowData?.user_id && rowData?.name
          ? {
              label: rowData.name,
              value: rowData.user_id,
            }
          : null,
      selectedRole:
        isEdit && rowData?.role_type
          ? {
              label: rowData.role_type,
              value: rowData.role_type,
            }
          : null,
      isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
    },
    validationSchema: ticketUserRoleSchema,
    onSubmit: async (values) => {
      const payload = {
        role_type: values.selectedRole?.value || "",
        user_id: values.selectedUser?.value || "",
        status: values.isActive ? "active" : "inactive",
      };

      // console.log("Submitting payload:", payload);

      const handleConfirm = async () => {
        const method = "POST";
        const endpoint = ticket_user_role_mapping;

        try {
          const result = await dispatch(
            commonPostPutApi({ method, endpoint, payload, token })
          );

          if (result?.payload?.status) {
            refetchTicketUserRoles();
            onCloseModal();
            toast.success(
              result?.payload?.message || "Role mapping updated successfully!"
            );
          } else {
            const errorMessage =
              result?.payload?.message || result?.error?.message;
            toast.error(errorMessage || "Something Went Wrong!");
          }
        } catch (error) {
          console.error("Error making POST request:", error);
          toast.error("Failed to update role mapping");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to ${
          isEdit ? "update" : "assign"
        } this user role mapping?`,
        "User Role Assignment",
        `${isEdit ? "Update" : "Assign"} Role`
      );
    },
  });

  // console.log("formik===>", formik);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Assign"} User Role`}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Assign"}
        onClose={onCloseModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedUser" className="formInputLabel">
              Select User <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formik.touched.selectedUser && formik.errors.selectedUser
                  ? "formError"
                  : ""
              }`}
            >
              <SelectDropdown
                options={inhouseUsers || []}
                selectedOption={formik.values.selectedUser}
                setSelectedOption={(selectedValue) =>
                  formik.setFieldValue("selectedUser", selectedValue)
                }
                name="Select User"
                preventKeyboardOpen={false}
                isDisabled={isEdit} // Disable user selection when editing
              />
            </div>
            {formik.touched.selectedUser && formik.errors.selectedUser ? (
              <div className="error-message">{formik.errors.selectedUser}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedRole" className="formInputLabel">
              Select Role Type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formik.touched.selectedRole && formik.errors.selectedRole
                  ? "formError"
                  : ""
              }`}
            >
              <SelectDropdown
                options={formatedTicketUserEnumData || []}
                selectedOption={formik.values.selectedRole}
                setSelectedOption={(selectedValue) =>
                  formik.setFieldValue("selectedRole", selectedValue)
                }
                name="Select Role Type"
                preventKeyboardOpen={true}
              />
            </div>
            {formik.touched.selectedRole && formik.errors.selectedRole ? (
              <div className="error-message">{formik.errors.selectedRole}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">Status</label>
            <div className="commonWrapper commonSwitchWrapper no-border">
              <label className="commonSwitch">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formik.values.isActive}
                  onChange={formik.handleChange}
                />
                <span className="slider round"></span>
              </label>
              <span className="formInputLabel">
                {formik.values.isActive ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default TicketUserForm;
